import { useLocation, useNavigate } from 'react-router'
import { useEffect } from 'react'
import { BroadcastsRoutes } from 'entities/ExportRouters'

const vuiToReact: { [key: string]: string } = {
  '/recurring': `/${BroadcastsRoutes.root}`,
  '/ringless': `/${BroadcastsRoutes.root}/${BroadcastsRoutes.oneTime}/${BroadcastsRoutes.ringless}`,
}

export const getLegacyVueRedirectPath = (pathname: string): string | undefined =>
  vuiToReact[pathname]

export function useRedirectRouter() {
  const { pathname } = useLocation()
  const navigate = useNavigate()
  useEffect(() => {
    if (pathname) {
      const reactRoute = getLegacyVueRedirectPath(pathname)
      if (reactRoute) {
        navigate(reactRoute)
      }
    }
  }, [pathname])
}
